import { Component, ElementRef, EventEmitter, Input, Output, inject } from '@angular/core';
import {Taak} from '../../../dienst/taak';
import {Dienst} from '../../../dienst/dienst';
import {Categorie} from '../../../dienst/categorie';
import {Prestatie} from '../../../prestatie/prestatie';
import UitgevoerdeTaak from '../../../prestatie/uitgevoerde-taak';
import {TaakTipAantal} from '../../../tip/taak-tip-aantal';

@Component({
    selector: 'zah-taken-list',
    templateUrl: './taken-list.component.html',
    styleUrls: ['./taken-list.component.scss'],
    standalone: false
})
export class TakenListComponent {
  private hostElement = inject(ElementRef);

  @Input()
  prestatie: Prestatie;
  @Input()
  dienst: Dienst;
  @Input()
  category: Categorie;
  @Input()
  taken: Array<Taak>;
  @Input()
  taakTipAantallen: Array<TaakTipAantal>;
  @Output()
  tipsOpened: EventEmitter<[string, string, string]> = new EventEmitter<[string, string, string]>();

  scrollTop(): void {
    this.hostElement?.nativeElement.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  getUitgevoerdeTaak(taak: Taak): UitgevoerdeTaak {
    return this.prestatie?.getUitgevoerdeTaak(
      this.dienst.getId(),
      this.category.getId(),
      taak.getId(),
    );
  }

  getTipAantal(taak: Taak): string {
    const taakTipAantal = this.taakTipAantallen
      .find(tipAantal => tipAantal.hasTaakId(taak.getId()) && tipAantal.hasCategorieId(this.category.getId()));
    const totaalAantalTips = taakTipAantal?.getTotaalAantalTips();
    return totaalAantalTips ? `(${totaalAantalTips})` : '';
  }

  onOpenTips(taak: Taak): void {
    this.tipsOpened.emit([this.dienst.getId(), this.category.getId(), taak.getId()]);
  }
}
